import { ESRI, GOOGLE } from '@rsos/maps/constants/mapProviders';

export const getGmapsViewState = mapInstance => {
  const center = mapInstance.getCenter();
  const latLng = new window.google.maps.LatLng(center.lat(), center.lng());
  const lat = latLng.lat();
  const lng = latLng.lng();
  const width = mapInstance.getDiv().offsetWidth;
  const height = mapInstance.getDiv().offsetHeight;
  const viewState = {
    longitude: lng,
    latitude: lat,
    width,
    height,
    zoom: normalizeZoomLevel(mapInstance, GOOGLE),
  };

  return viewState;
};

/**
 * Normalize the zoom level for getViewState for deck.gl to properly handle
 * converting coordinates to pixels on the screen with deck.gl's `viewport`.
 * See more info here https://medium.com/vis-gl/using-deck-gl-with-google-maps-9c868d18e3cd
 * @param {Instance} mapInstance
 * @param {String} mapProvider - ESRI or GOOGLE
 */
export const normalizeZoomLevel = (mapInstance, mapProvider) => {
  if (mapProvider === ESRI) {
    return mapInstance.view.zoom;
  } else if (mapProvider === GOOGLE) {
    return mapInstance.getZoom() - 1;
  }
};
